export default "__VITE_ASSET__CpyjrjmQ__"